import { Code } from "helpers/CalendarImports";
import { CommonDataColumn } from "models/BaseModel";

const empty = '&nbsp;';

export function HtmlDataFormat(type: number | undefined, data: string | undefined): string {
  if(!data) return '';

  
  let parsed: CommonDataColumn;
  
  try {
    parsed = JSON.parse(data) as CommonDataColumn;

    //const type = Number(parsed.TYPE);
    switch (type) {
      case Code.Option.Control.FRAME:
        return FrameHtmlData(parsed);
      
      case Code.Option.Control.EXAM:
        return PrescriptionHtmlData(parsed);

      case Code.Option.Control.LENS:
        return LensHtmlData(parsed);

      case Code.Option.Control.CONTACTLENS:
        return ContactLensHtmlData(parsed);
      
      case Code.Option.Control.HEARING:
        return HearingHtmlData(parsed);

      case Code.Option.Control.STOCKING:
        return StockingHtmlData(parsed);  
      
      default:
        return '';
    }
  } catch {
    return ''; 
  }
}

function FrameHtmlData(data: CommonDataColumn): string  {
  return `
    <table class="format11">
      <tr>
        <td class="fcol1 fwb bce">Line</td>
        <td class="fcol2 fwb bce">Model</td>
        <td class="fcol3 fwb bce">Size</td>
        <td class="fcol4 fwb bce">A</td>
        <td class="fcol5 fwb bce">B</td>
        <td class="fcol6 fwb bce">ED</td>
      </tr>
      <tr>
        <td>${data.D41 ?? empty}</td>
        <td>${data.D61 ?? empty}</td>
        <td>${data.D43 ?? empty}</td>
        <td>${data.D44 ?? empty}</td>
        <td>${data.D45 ?? empty}</td>
        <td>${data.D46 ?? empty}</td>
      </tr>
      <tr>
        <td class="fwb bce">Colour</td>
        <td colspan="2">${data.D54 ?? empty}</td>
        <td class="fwb bce">Wrap</td>
        <td colspan="2">${data.D47 ?? empty}</td>
      </tr>
    </table>
  `;
}

function PrescriptionHtmlData (data: CommonDataColumn):string {
  console.log("PrescriptionHtmlData---->",data)
  return `
    <table class="format12">
      <tr class="fwb">
        <td class="fcol1 bce">&nbsp;</td>
        <td class="fcol2 bce">Sphere</td>
        <td class="fcol3 bce">Cylinder</td>
        <td class="fcol4 bce">Axis</td>
        <td class="fcol5 bce">Add</td>
      </tr>
      <tr>
        <td class="fwb bce">OD</td>
        <td>${data.R67 ?? empty}</td>
        <td>${data.R68 ?? empty}</td>
        <td>${data.R69 ?? empty}</td>
        <td>${data.R75 ?? empty}</td>
      </tr>
      <tr>
        <td class="fwb bce">OS</td>
        <td>${data.L67 ?? empty}</td>
        <td>${data.L68 ?? empty}</td>
        <td>${data.L69 ?? empty}</td>
        <td>${data.L75 ?? empty}</td>
      </tr>
      <tr class="fwb">
        <td class="bce">&nbsp;</td>
        <td class="bce">AV</td>
        <td class="bce">PD</td>
        <td class="bce">Height</td>
        <td class="bce">Prism</td>
      </tr>
      <tr>
        <td class="fwb bce">OD</td>
        <td>${data.R70 ?? empty}</td>
        <td>${data.R135 ?? data.R111 ?? empty}</td>
        <td>${data.R114 ?? empty}</td>
        <td>${data.R71 ?? empty} ${data.R72 ?? empty}</td>
      </tr>
      <tr>
        <td class="fwb bce">OS</td>
        <td>${data.L70 ?? empty}</td>
        <td>${data.L135 ?? data.L111 ?? empty}</td>
        <td>${data.L114 ?? empty}</td>
        <td>${data.L71 ?? empty} ${data.L72 ?? empty}</td>
      </tr>
    </table>
  `;
};

function LensHtmlData(data: CommonDataColumn):string {
  return `
    <table class="format13">
      <tr>
        <td class="fcol1 fwb bce">Lab</td>
        <td class="fcol2 fwb bce">Lens</td>
        <td class="fcol3 fwb bce">Style</td>
        <td class="fcol4 fwb bce">Material</td>
      </tr>
      <tr>
        <td>${data.D55 ?? empty}</td>
        <td>${data.D57 ?? empty}</td>
        <td>${data.D59 ?? empty}</td>
        <td>${data.D56 ?? empty}</td>
      </tr>
    </table>
  `;
};

function HearingHtmlData(data: CommonDataColumn):string {
  return `
    <table class="format13">
      <tr>
        <td class="fcol1 fwb bce">Brand</td>
        <td class="fcol2 fwb bce">Model</td>
        <td class="fcol3 fwb bce">Color</td>
        <td class="fcol4 fwb bce">Size</td>
      </tr>
      <tr>
        <td>${data.D77 ?? empty}</td>
        <td>${data.D78 ?? empty}</td>
        <td>${data.D79 ?? empty}</td>
        <td>${data.D81 ?? empty}</td>
      </tr>
    </table>
  `;
};

function StockingHtmlData(data: CommonDataColumn):string {
  return `
    <table class="format13">
      <tr>
        <td class="fcol1 fwb bce">Brand</td>
        <td class="fcol2 fwb bce">Type</td>
        <td class="fcol2 fwb bce">Size</td>
        <td class="fcol3 fwb bce">Compression</td>
        <td class="fcol4 fwb bce">Colour</td>
      </tr>
      <tr>
        <td>${data.D69 ?? empty}</td>
        <td>${data.D70 ?? empty}</td>
        <td>${data.D71 ?? empty}</td>
        <td>${data.D72 ?? empty}</td>
        <td>${data.D73 ?? empty}</td>
      </tr>
    </table>
  `;
};

function ContactLensHtmlData(data: CommonDataColumn):string {
  return `
    <table class="format13 tcenter">
      <tr>
        <td class="fcol1 fwb bce">&nbsp;</td>
        <td class="fcol1 fwb bce">BC</td>
        <td class="fcol2 fwb bce">Dia</td>
        <td class="fcol2 fwb bce">Sphere</td>
        <td class="fcol3 fwb bce">Cylinder</td>
        <td class="fcol4 fwb bce">Axis</td>
        <td class="fcol4 fwb bce">Add</td>
      </tr>
      <tr>
        <td class="fwb bce tright">OD</td>
        <td>${data.R195 ?? empty}</td>
        <td>${data.R196 ?? empty}</td>
        <td>${data.R191 ?? empty}</td>
        <td>${data.R192 ?? empty}</td>
        <td>${data.R193 ?? empty}</td>
        <td>${data.R194 ?? empty}</td>
      </tr>
      <tr>
        <td class="fwb bce tright">OS</td>
        <td>${data.L195 ?? empty}</td>
        <td>${data.L196 ?? empty}</td>
        <td>${data.L191 ?? empty}</td>
        <td>${data.L192 ?? empty}</td>
        <td>${data.L193 ?? empty}</td>
        <td>${data.L194 ?? empty}</td>
      </tr>
    </table>

    <table class="format13 tcenter mt2">
      <tr>
        <td class="fcol1 fwb bce">&nbsp;</td>
        <td class="fcol1 fwb bce">OD</td>
        <td class="fcol2 fwb bce">OS</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">Lab</td>
        <td>${data.R187 ?? empty}</td>
        <td>${data.L187 ?? empty}</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">CL Type</td>
        <td>${data.R188 ?? empty}</td>
        <td>${data.L188 ?? empty}</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">Lens</td>
        <td>${data.R189 ?? empty}</td>
        <td>${data.L189 ?? empty}</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">Colour</td>
        <td>${data.R190 ?? empty}</td>
        <td>${data.L190 ?? empty}</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">Quantity</td>
        <td>${data.R237 ?? empty}</td>
        <td>${data.L237 ?? empty}</td>
      </tr>
      <tr>
        <td class="fcol1 fwb bce">Notes</td>
        <td colspan="2">${data.C63 ?? empty}</td>
      </tr>
    </table>
  `;
};